import flatten from 'lodash-es/flatten';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { FetchProspects, IProspectApiResponse, prospectActionCreators, ProspectsActionKeys } from '..';
import { IState } from '../..';
import { addressActionCreators, IAddress } from '../../address';
import { IPagedSegmentResponse } from '../../apiInterfaces';
import { businessEntityActionCreators } from '../../businessEntity';
import { FilterTypes, getFilteredSalesDistricts, getFilters, ISalesProspectsFilters } from '../../filters';
import * as api from '../prospectsApi';

function* fetchProspectsSaga(action: FetchProspects) {
  yield put(prospectActionCreators.showLoading());

  const filters: ISalesProspectsFilters = yield select((state: IState) =>
    getFilters(state, FilterTypes.salesProspects)
  );

  const sds: string[] = yield select((state: IState) => getFilteredSalesDistricts(state, filters));

  const result: IPagedSegmentResponse<IProspectApiResponse> = yield call(
    api.FetchProspects,
    sds,
    filters,
    action.payload.skip
  );

  //set the addresses
  const addresses: IAddress[] = flatten(result.items.map(x => x.addresses));
  yield put(
    businessEntityActionCreators.addAddresses(
      result.items.map(x => ({
        addressIds: x.addresses.map(y => y.addressId),
        businessEntityId: x.businessEntityId
      }))
    )
  );
  yield put(addressActionCreators.setAddresses(addresses));

  // add the names
  yield put(
    businessEntityActionCreators.addNames(
      result.items.map(x => ({ businessEntityId: x.businessEntityId, name: x.name }))
    )
  );

  yield put(
    prospectActionCreators.setTotalItems({
      prospectStatusId: filters.prospectStatusId,
      totalItems: result.totalItems
    })
  );

  yield put(prospectActionCreators.setProspects(result.items));

  //

  yield put(prospectActionCreators.hideLoading());
}

export function* watchFetchProspects() {
  yield takeEvery(ProspectsActionKeys.FETCH_PROSPECTS, fetchProspectsSaga);
}
